import  { createContext } from "react";

const CoinContext = createContext({
  coin: "",
  setCoin: () => {},
});

export default CoinContext;
